import { registerPlugin } from "@capacitor/core";

import { DeviceInformationPlugin } from "./definitions";
import { CAPACITOR_DEVICE_INFORMATION_PLUGIN } from "../pluginConstants";

const DeviceInformation = registerPlugin<DeviceInformationPlugin>(CAPACITOR_DEVICE_INFORMATION_PLUGIN);

export * from './definitions';
export { DeviceInformation };